import { HttpClient } from '@magiczne/http-client'

const client = new HttpClient()

export {
    client as default
}
